class FreeShippingProgress extends HTMLElement {
  static lastProgress = null;

  connectedCallback() {
    const progress = Number(this.dataset.progress) || 0;
    const previous = FreeShippingProgress.lastProgress;
    FreeShippingProgress.lastProgress = progress;

    if (previous === null || previous === progress) return;

    this.setProgress(previous);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.setProgress(progress));
    });
  }

  setProgress(value) {
    this.style.setProperty('--free-shipping-progress', `${value}%`);
  }
}

if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', FreeShippingProgress);
}
